import { getHttpClient } from '../axiosInstance'

const base = '/manager/jobs/v1'

// TODO: Cambiar endpoint
export const load = async (id) => {
  const apiClient = getHttpClient()
  // const url = `${base}/${id}`
  const url = `/react/v1/jobs/${id}`

  const response = await apiClient.get(url)
  return response.data
}

// TODO: Unificar con load 
export const loadDto = async (id) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}`

  const response = await apiClient.get(url)
  return response.data
}

export const vendorList = async (id, taskId) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/task/${taskId}/vendors`

  const response = await apiClient.get(url)
  return response.data
}

// TODO: Cambiar endpoint
export const updateTaskVendorModal = async (id, { taskId, form }) => {
  const apiClient = getHttpClient()
  const url = `/react/v1/jobs/${id}/tasks/${taskId}/update-vendor`

  const response = await apiClient.put(url, form)
  return response.data
}

export const createQA = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/qa`

  const response = await apiClient.post(url, form)
  return response.data
}

export const updateQA = async (id, values) => {
  const apiClient = getHttpClient()
  const { qaId, ...form } = values
  const url = `${base}/${id}/qa/${qaId}`

  const response = await apiClient.put(url, form)
  return response.data
}

export const removeQA = async (id, qaId) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/qa/${qaId}`
  const response = await apiClient.delete(url, {})
  return response.data
}

export const createQAComment = async (id, values) => {
  const apiClient = getHttpClient()
  const { qaId, ...form } = values
  const url = `${base}/${id}/qa/${qaId}/comment`

  const response = await apiClient.post(url, form)
  return response.data
}

export const removeQAComment = async (id, values) => {
  const apiClient = getHttpClient()
  const { qaId, commentId } = values

  const url = `${base}/${id}/qa/${qaId}/comment/${commentId}`
  const response = await apiClient.delete(url, {})
  return response.data
}

export const createQAScorecard = async (id, { qaId, form }) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/qa/${qaId}/scorecard`

  const response = await apiClient.post(url, form)
  return response.data
}

export const downloadQAScorecard = async (id, { qaId, name }) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/qa/${qaId}/scorecard`
  const response = await apiClient.get(url, { responseType: 'arraybuffer' })

  const anchorUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = anchorUrl
  link.setAttribute('download', `${name}`)
  document.body.appendChild(link)
  link.click()

  return null // response.data
}

export const removeQAScorecard = async (id, qaId) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/qa/${qaId}/scorecard`

  const response = await apiClient.delete(url, {})
  return response.data
}

export const postBitacoraMessage = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/bitacora`

  const response = await apiClient.post(url, form)
  return response.data
}



export const updateStatus = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/update-status`

  const response = await apiClient.put(url, form)
  return response.data
}

export const updatePrices = async (id) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/update-prices`

  const response = await apiClient.put(url, {})
  return response.data
}

export const clientConfirmation = async (id) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/client-status`

  const response = await apiClient.put(url, { status: 'Confirmed' })
  return response.data
}

export const satisfactionStatus = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/satisfaction-status`

  const response = await apiClient.put(url, form)
  return response.data
}

export const createStorage = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}/storage`

  const response = await apiClient.post(url, form)
  return response.data
}

// TODO: Cambiar endpoint
export const updateTaskStatus = async (id, { taskId, form }) => {
  const apiClient = getHttpClient()
  const url = `/react/v1/jobs/${id}/tasks/${taskId}/update-status`

  const response = await apiClient.put(url, form)
  return response.data
}

// TODO: Cambiar endpoint
export const createTask = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `/react/v1/jobs/${id}/tasks`

  const response = await apiClient.post(url, form)
  return response.data
}

// TODO: Cambiar endpoint
export const updateTask = async (id, values) => {
  const apiClient = getHttpClient()
  const { taskId, form } = values
  const url = `/react/v1/jobs/${id}/tasks/${taskId}`

  const response = await apiClient.put(url, form)
  return response.data
}

// TODO: Cambiar endpoint
export const removeTask = async (id, taskId) => {
  const apiClient = getHttpClient()
  const url = `/react/v1/jobs/${id}/tasks/${taskId}`

  const response = await apiClient.delete(url, {})
  return response.data
}











export const fetchWithPagination = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = `${base}/`
  /**
   * Add hidden parameters to make the API call
   */
  const hiddenParams = {}

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const toggle = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/toggle/${id}`
  const response = await apiClient.put(url, {})
  return response.data
}

export const remove = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}`
  const response = await apiClient.delete(url, {})
  return response.data
}


export const create = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/form`

  const response = await apiClient.post(url, form)
  return response.data
}

export const update = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/form/${id}`

  const response = await apiClient.put(url, form)
  return response.data
}
